/**
 * @description: 门店设置首页
 * @author: hwx
 * @update: lyr(2022-03-02)
*/
<template>
    <div class="store-set">
        <div class="list-tit" v-show="showIndex">
            <div class="row big-privilege-menu" id="set_967">
                <h1>营业设置</h1>
                <ul>
					<li class="col-md-4 privilege-menu" id="set_968"><span @click="titClk('business','1')">微信/支付宝端支付方式配置</span></li>
					<li class="col-md-4 privilege-menu" id="set_969"><span @click="titClk('business','2')">app支付方式设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_970"><span @click="titClk('business','3')">app会员支付是否开启密码验证</span></li>
					<li class="col-md-4 privilege-menu" id="set_971"><span @click="titClk('business','4')">app任务自动接收</span></li>
					<li class="col-md-4 privilege-menu" id="set_972"><span @click="titClk('business','5')">扫微信取酒二维码设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_973"><span @click="titClk('business','6')">微信端播控设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_974"><span @click="titClk('business','7')">挂账人担保人是否需要密码验证</span></li>
					<li class="col-md-4 privilege-menu" id="set_975"><span @click="titClk('business','8')">app历史任务权限是否细分到账号</span></li>
					<li class="col-md-4 privilege-menu" id="set_976"><span @click="titClk('business','9')">结账是否进行员工验证</span></li>
					<li class="col-md-4 privilege-menu" id="set_977"><span @click="titClk('business','10')">包厢营业额预警设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_978"><span @click="titClk('business','11')">经理打折是否剔除不打折商品</span></li>
					<li class="col-md-4 privilege-menu" id="set_979"><span @click="titClk('business','12')">会员刷卡是否允许手动输入卡号</span></li>
					<li class="col-md-4 privilege-menu" id="set_980"><span @click="titClk('business','13')">计时开房是否支持跨时段</span></li>
					<li class="col-md-4 privilege-menu" id="set_981"><span @click="titClk('business','14')">取消开房时限设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_982"><span @click="titClk('business','15')">团购套餐兑券是否授权销券</span></li>
					<li class="col-md-4 privilege-menu" id="set_983"><span @click="titClk('business','16')">全场霸屏设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_984"><span @click="titClk('business','17')">会员到店预警设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_985"><span @click="titClk('business','18')">智慧麦克风低电量消息提醒</span></li>
					<li class="col-md-4 privilege-menu" id="set_986"><span @click="titClk('business','19')">会员折扣是否仅会员支付时生效</span></li>
					<li class="col-md-4 privilege-menu" id="set_987"><span @click="titClk('business','20')">暂停营业时间设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_988"><span @click="titClk('business','21')">酒水服务费是否参与账单经理打折</span></li>
					<li class="col-md-4 privilege-menu" id="set_989"><span @click="titClk('business','22')">每次开房可使用券总量</span></li>
					<li class="col-md-4 privilege-menu" id="set_990"><span @click="titClk('business','23')">支付时优惠券是否打折</span></li>
					<li class="col-md-4 privilege-menu" id="set_991"><span @click="titClk('business','24')">自助大厅支付形式设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_992"><span @click="titClk('business','25')">微信在线预定类型</span></li>
					<li class="col-md-4 privilege-menu" id="set_993"><span @click="titClk('business','26')">手机短信类型模板设置</span></li>
					<li class="col-md-4 privilege-menu" id="set_994"><span @click="titClk('business','27')">经理实收是否需要密码验证</span></li>
					<li class="col-md-4 privilege-menu" id="set_995"><span @click="titClk('business','28')">账单低消部分是否参与经理打折</span></li>
					<li class="col-md-4 privilege-menu" id="set_996"><span @click="titClk('business','29')">商品赠送是否需要密码验证</span></li>
					<li class="col-md-4 privilege-menu" id="set_997"><span @click="titClk('business','30')">经理打折是否需要密码验证</span></li>
					<li class="col-md-4 privilege-menu" id="set_998"><span @click="titClk('business','31')">微信扫码是否默认办理会员卡</span></li>
					<li class="col-md-4 privilege-menu" id="set_999"><span @click="titClk('business','32')">app下单默认导购员设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1063"><span @click="titClk('business','33')">APP刷卡业务账号登录是否需要密码验证</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1062"><span @click="titClk('business','34')">开房剩余时长预警设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1095"><span @click="titClk('business','35')">花单金额是否与账单金额合并支付</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1096"><span @click="titClk('business','36')">包厢状态图当前消费与未收款是否包含花单金额</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1129"><span @click="titClk('business','37')">不满低消时酒水服务费统计方式设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1165"><span @click="titClk('business','38')">自助大厅扫码登录是否默认办理会员卡</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1172"><span @click="titClk('business','39')">会员积分兑换是否支持连锁门店通用</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1199"><span @click="titClk('business','40')">收银交接是否包含花单金额</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1200"><span @click="titClk('business','41')">微信端会员条码显示设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1201"><span @click="titClk('business','42')">账单员工可赠送比例金额是否扣除已赠送金额</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1246"><span @click="titClk('business','43')">客遗回收入库默认设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1248"><span @click="titClk('business','44')">点单收银待支付划线价显示</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1266"><span @click="titClk('business','45')">报表默认检索时间设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1267"><span @click="titClk('business','46')">订台业绩是否包含未收款金额</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1281"><span @click="titClk('business','47')">班次设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1298"><span @click="titClk('business','48')">收银app包厢状态图设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1306"><span @click="titClk('business','49')">团购平台类型设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1307"><span @click="titClk('business','50')">会员资料必填项设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1308"><span @click="titClk('business','51')">微信端优惠券显示设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1313"><span @click="titClk('business','52')">排队取号会员是否独立排号</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1314"><span @click="titClk('business','53')">排队取号叫号语音文本设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1328"><span @click="titClk('business','54')">服务评价管理设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1331"><span @click="titClk('business','55')">账单自助付款功能设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1334"><span @click="titClk('business','56')">会员自助注册用户协议设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1335"><span @click="titClk('business','57')" v-if="business_model==2">在线预订回执设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1337"><span @click="titClk('business','58')">包厢状态新增预定必填项设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1361"><span @click="titClk('business','59')">智慧超市设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1363"><span @click="titClk('business','60')">到店指引设置</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1000">
                <h1>单据设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1001"><span class="col-md-12" @click="titClk('bill', '1')">账单商品明细是否合并设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1002"><span class="col-md-12" @click="titClk('bill', '2')">交接单金额为0元是否显示</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1003"><span class="col-md-12" @click="titClk('bill', '3')">账单预定信息是否可修改</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1004"><span class="col-md-12" @click="titClk('bill', '4')">账单内低消商品增加‘低’的标记</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1097"><span class="col-md-12" @click="titClk('bill', '5')">送花账单明细是否合并设置</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1005">
                <h1>寄存设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1006"><span class="col-md-12" @click="titClk('deposit', '1')">取酒判断包厢是否消费中</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1007"><span class="col-md-12" @click="titClk('deposit', '2')">过期酒水自动充公设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1008"><span class="col-md-12" @click="titClk('deposit', '3')">app新增存酒单必填项设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1009"><span class="col-md-12" @click="titClk('deposit', '4')">寄存酒即将到期消息提醒设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1010"><span class="col-md-12" @click="titClk('deposit', '5')">取酒是否支持修改取酒数量</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1011"><span class="col-md-12" @click="titClk('deposit', '6')">是否支持微信自助存取酒</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1309"><span class="col-md-12" @click="titClk('deposit', '7')">微信端存酒单显示设置</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1012">
                <h1>点歌系统设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1013"><span class="col-md-12" @click="titClk('vod', '1')">包厢后买单设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1014"><span class="col-md-12" @click="titClk('vod', '2')">触摸屏wifi显示设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1015"><span class="col-md-12" @click="titClk('vod', '3')">触摸屏屏保设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1016"><span class="col-md-12" @click="titClk('vod', '4')">触摸屏呼叫服务设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1017"><span class="col-md-12" @click="titClk('vod', '5')">disco限制播放时间设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1018"><span class="col-md-12" @click="titClk('vod', '6')">网关检测设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1019"><span class="col-md-12" @click="titClk('vod', '7')">触摸屏下单人员是否默认导购员设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1064"><span class="col-md-12" @click="titClk('vod', '8')">触摸屏点单推荐设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1065"><span class="col-md-12" @click="titClk('vod', '9')">触摸屏点单热搜词设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1340"><span class="col-md-12" @click="titClk('vod', '10')">触摸屏包厢账单是否显示送花结账单</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1368"><span class="col-md-12" @click="titClk('vod', '11')">大厅自助台球语音播报设置</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1020">
                <h1>仓库设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1021"><span class="col-md-12" @click="titClk('store', '1')">商品库存不足出货设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1022"><span class="col-md-12" @click="titClk('store', '2')">报表进货价显示设置</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1023">
                <h1>打印单据设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1024"><span class="col-md-12" @click="titClk('print', '1')">商品总单打印设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1025"><span class="col-md-12" @click="titClk('print', '2')">账单是否自动打印</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1026"><span class="col-md-12" @click="titClk('print', '3')">账单打印是否显示赠送商品金额</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1027"><span class="col-md-12" @click="titClk('print', '4')">取酒单是否显示已取和剩余酒水明细</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1028"><span class="col-md-12" @click="titClk('print', '5')">打印的单据是否自动打印</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1029"><span class="col-md-12" @click="titClk('print', '6')">开房单备注设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1030"><span class="col-md-12" @click="titClk('print', '7')">交接单底部是否留白</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1031"><span class="col-md-12" @click="titClk('print', '8')">账单的门店地址和电话是否隐藏</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1032"><span class="col-md-12" @click="titClk('print', '9')">账单结尾内容定义</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1033"><span class="col-md-12" @click="titClk('print', '10')">员工还款后打印商品订单</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1034"><span class="col-md-12" @click="titClk('print', '11')">打印单据的会员信息是否隐藏</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1035"><span class="col-md-12" @click="titClk('print', '12')">付款记录是否隐藏</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1094"><span class="col-md-12" @click="titClk('print', '13')">账单打印内容是否包含送花账单信息</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1128"><span class="col-md-12" @click="titClk('print', '14')">商品备货单是否显示合计金额</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1173"><span class="col-md-12" @click="titClk('print', '15')">账单打印是否显示套餐明细</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1174"><span class="col-md-12" @click="titClk('print', '16')">账单打印是否显示低消金额</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1036">
                <h1>艺人设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1037"><span class="col-md-12" @click="titClk('personnel', '1')">艺人资料必填项设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1038"><span class="col-md-12" @click="titClk('personnel', '2')">艺人报备设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1039"><span class="col-md-12" @click="titClk('personnel', '3')">艺人签到后多久可签退</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1040"><span class="col-md-12" @click="titClk('personnel', '4')">艺人是否支持手动扫码下钟</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1041"><span class="col-md-12" @click="titClk('personnel', '5')">未签到是否支持上钟打卡</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1148"><span class="col-md-12" @click="titClk('personnel', '6')">台票购买设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1149"><span class="col-md-12" @click="titClk('personnel', '7')">艺人上钟模式设置</span></li>
                </ul>
            </div>
            <div class="row big-privilege-menu" id="set_1042">
                <h1>系统设置</h1>
                <ul>
                    <li class="col-md-4 privilege-menu" id="set_1043"><span class="col-md-12" @click="titClk('system', '1')">清空数据设置</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1044"><span class="col-md-12" @click="titClk('system', '2')">版权歌曲</span></li>
                    <li class="col-md-4 privilege-menu" id="set_1045"><span class="col-md-12" @click="titClk('system', '3')">歌曲删除</span></li>
                </ul>
            </div>
        </div>
        <div>
            <!-- 营业设置 -->
            <router-view name="business" ref="business" @targetBack="showIndexPage"></router-view>
            <!-- 单据设置 -->
            <router-view name="bill" ref="bill" @targetBack="showIndexPage"></router-view>
            <!-- 寄存设置 -->
            <router-view name="deposit" ref="deposit" @targetBack="showIndexPage"></router-view>
            <!-- 点歌系统设置 -->
            <router-view name="vod" ref="vod" @targetBack="showIndexPage"></router-view>
            <!-- 仓库设置 -->
            <router-view name="store" ref="store" @targetBack="showIndexPage"></router-view>
            <!-- 打印单据设置 -->
            <router-view name="print" ref="print" @targetBack="showIndexPage"></router-view>
            <!-- 艺人设置 -->
            <router-view name="personnel" ref="personnel" @targetBack="showIndexPage"></router-view>
            <!-- 系统设置 -->
            <router-view name="system" ref="system" @targetBack="showIndexPage"></router-view>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showIndex: true,
                scollPostion: '',
                bigPrivilegeList: [], // 大菜单权限
                privilegeList: [], // 子菜单权限
            }
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if(val.params.url_index) {
                        this.titClk(val.params.url_name, val.params.url_index)
                    }
                    if (val.name == 'store_set' && !val.params.url_name) {// 解决切换其他tab页回来变空白问题
                        this.showIndex = true
                    }
                },
                deep: true
            },
        },
        computed: {
            // 社区模式
            business_model() {
                return this.$store.state.business_model
            },
        },
        mounted: function() {
            // 第一次打开
            this.menu()
            if(this.$route.params.url_index) {
                this.titClk(this.$route.params.url_name, this.$route.params.url_index)
            }
        },
        methods: {
            // 获取菜单权限
            menu() {
                let _this = this,
                    menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    $.each(menu, function(k, v) {
                        if(v.id == '546') { // 设置
                            menu = v.submenu;
                            $.each(menu, function(m, n) {
                                if(n.name == '门店设置') {
                                    menu = n.submenu;
                                    $.each(menu, function(x, y) {
                                        menu = y.submenu;
                                        _this.bigPrivilegeList.push('set_' + y.id)
                                        $.each(menu, function(i, j) {
                                            _this.privilegeList.push('set_' + j.id)
                                        })
                                    });
                                }
                            });
                        }
                    });
                }

                var bigmenuDom = $(".big-privilege-menu").toArray()
                bigmenuDom.forEach((k, v) => {
                    var id = k.getAttribute('id').toString()
                    if (!_this.bigPrivilegeList.includes(id)) {
                        k.style = 'display:none'
                    }
                })

                var submenuDom = $(".privilege-menu").toArray()
                submenuDom.forEach((k, v) => {
                    var id = k.getAttribute('id').toString()
                    if (!_this.privilegeList.includes(id)) {
                        k.style = 'display:none'
                    }
                })
            },

            titClk: function(name, num) {
                this.scollPostion = $('.el-tabs__content').scrollTop()
                this.showIndex = false
                this.$nextTick(() => {
                    this.$refs[`${name}`].showTargetPage(num)
                })
            },
            showIndexPage: function() {
                this.showIndex = true
                this.$nextTick(function() {
                    $('.el-tabs__content').scrollTop(this.scollPostion)
                })
            },
        }
    }
</script>
<style lang="less">
    .list-tit span {
        display: block;
        border: 1px solid #CCC;
        margin: 0 0 30px;
        line-height: 50px;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        border-radius: 10px;
    }
    .title {
        margin: 0 0 20px;
        font-size: 26px;
        text-align: center;
    }
    .select-sel {
        outline: none;
        width: 100px;
        border: none;
        cursor: pointer;
    }
    .select-sel.middle-size {
        width: 220px;
    }
    .select-sel-big {
        outline: none;
        width: 70%;
        border: none;
        cursor: pointer;
    }
    .input-val {
        height: 30px;
        padding: 0 8px;
        margin: 0 10px 0 0;
        border: 1px solid #d6d6d6;
    }

    // 营业设置 - 智慧麦克风低电量消息提醒
    .store-mdx-set {
        .mdx-edit {
            display: block;
            cursor: pointer;
            i {
                margin: 0 0 0 30px;
            }
        }
    }

    // 打印单据设置 - 开房单备注设置
    .store-kfb-set {
        .kfb-remark {
            resize: none;
            width: 80%;
            height: 100px;
            line-height: 26px;
        }
        .kfb-bill {
            display: none;
            >div {
                padding: 10px 20px;
                border: 1px solid #CCC;
                h2 {
                    font-size: 16px;
                    text-align: center;
                }
            }
        }
    }
</style>